import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
//

//namespace SlotGames {

export class CloverGirlGold10Deluxe_Responsive extends SlotGameType1_Responsive {

    protected override helpFactory: IHelpFactory = new CloverGirlGold10DeluxeHelpFactory();

    protected override color: RewardColor =
    {
        color: "yellow",
        coloroutherStroke: "black",
        colorinnerStroke: "red",
    }

    public override isDeluxGame: boolean = true;
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "CloverGirlGold10Deluxe") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }

}

class CloverGirlGold10DeluxeHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new CloverGirlGold10DeluxeHelp(params);
    }
}

class CloverGirlGold10DeluxeHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
